const createFilePicker = (onSelect, acceptedFiles) => {
  if (typeof onSelect !== 'function') {
    console.error('createFilePicker: onSelect must be a function')
    return
  }
  const input = document.createElement('input')
  input.type = 'file'
  input.multiple = true
  input.accept = acceptedFiles || ''
  input.style.display = 'none'
  let isCleanedUp = false

  const cleanup = () => {
    if (isCleanedUp) return
    isCleanedUp = true

    if (input.parentNode) {
      input.parentNode.removeChild(input)
    }

    window.removeEventListener('focus', handleFocus)
    input.removeEventListener('cancel', cleanup)
  }

  input.addEventListener('change', (event) => {
    const files = Array.from(event.target.files || [])
    try {
      if (files.length > 0) {
        onSelect(files)
      }
    } finally {
      cleanup()
    }
  })
  input.addEventListener('cancel', cleanup)

  const handleFocus = () => {
    setTimeout(() => {
      cleanup()
    }, 100)
  }
  window.addEventListener('focus', handleFocus)

  document.body.appendChild(input)

  requestAnimationFrame(() => {
    input.click()
  })
}

export default createFilePicker
